module.exports = __webpack_public_path__ + "static/media/icon_plus_red.b8ff7339.svg";